import React from "react";
import {
  GlobeIcon,
  SettingsIcon,
  CalendarIcon,
  BarChart2Icon,
  SmartphoneIcon,
  CreditCardIcon,
  DollarSign, // Used for calendar/payments representation
} from "lucide-react";

const DynamicContent = ({ bgImage }) => (
  <div
    className="partners-benefits-icon-content"
    style={{
      backgroundImage: `url(${bgImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      minHeight: "150px",
      borderRadius: "10px",
    }}
  ></div>
);

const partnersBenefitsData = [
  {
    icon: GlobeIcon,
    title: "Competitive, Transparent Rewards",
    bgImage: "/images/partners/partners_1.png",
    backContent: [
      "Earn industry-leading commissions with a clear, straightforward payout structure.",
      "No hidden tiers, no volume traps, just predictable earnings aligned with your long-term growth.",
    ],
  },
  {
    icon: SettingsIcon,
    title: "A Platform Traders Trust",
    bgImage: "/images/partners/partners_2.png",
    backContent: [
      "Your referrals get access to tight spreads, fast execution, regulated operations, and seamless support.",
      "We help you build credibility through a partnership that prioritizes client protection.",
    ],
  },
  {
    icon: CalendarIcon,
    title: "Marketing Support That Scales With You",
    bgImage: "/images/partners/partners_3.png",
    backContent:
      "From branded assets to analytics dashboards and personalized consultation, we equip you with all the tools you need to attract, engage, and retain your audience.",
  },
  {
    icon: BarChart2Icon,
    title: "Global Presence, Local Support",
    bgImage: "/images/partners/partners_4.png",
    backContent: [
      "Expand your reach with a brand trusted by over 2 million traders across 100+ countries.",
      "While our footprint is global, our support remains personal, offering partners localized insights, region-specific materials, and culturally aligned strategies that help you connect meaningfully with your audience.",
    ],
  },
  {
    icon: SmartphoneIcon,
    title: "Seamless Integrations & Partner-Friendly Infrastructure",
    bgImage: "/images/partners/partners_5.png",
    backContent: [
      "Our systems are built to empower partners with efficiency.",
      "From frictionless onboarding to advanced referral tracking and CRM integrations, every part of our infrastructure is designed to help you operate smoothly, reduce administrative work, and focus on growth.",
    ],
  },
  {
    icon: CreditCardIcon,
    title: "A Reputation That Elevates Yours",
    bgImage: "/images/partners/partners_6.png",
    backContent: [
      "As a partner, you align with a platform known for reliability, transparent operations, and industry-grade security.",
      "This credibility directly strengthens your own brand, helping you gain trust faster and convert more efficiently, because standing with The Pips means standing with a proven market leader.",
    ],
  },
];

const PartnersContentTwo = () => {
  return (
    <div className="container">
      <div className="partners-benefits-section">
        <div className="partners-benefits-header">
          <h1 className="partners-benefits-main-title">
            Built to Empower You. Designed for Your Growth.
          </h1>
        </div>

        <div className="partners-benefits-cards-container">
          {partnersBenefitsData.map((benefit, index) => (
            <div key={index} className="partners-benefits-card-wrapper">
              <div className="partners-benefits-card">
                {/* Card Front */}
                <div className="partners-benefits-card-front">
                  <h2 className="partners-benefits-card-title">
                    {benefit.title}
                  </h2>
                  <div className="partners-benefits-card-content">
                    <DynamicContent bgImage={benefit.bgImage} />
                  </div>
                </div>

                {/* Card Back (Flipping content) */}
                <div className="partners-benefits-card-back">
                  <div className="partners-benefits-card-icon-back">
                    <benefit.icon size={40} />
                  </div>
                  {/* <h2 className="partners-benefits-card-title-back">
                  {benefit.title}
                </h2> */}
                  {Array.isArray(benefit.backContent) ? (
                    benefit.backContent.map((line, i) => (
                      <p key={i} className="partners-benefits-card-description">
                        {line}
                      </p>
                    ))
                  ) : (
                    <p className="partners-benefits-card-description">
                      {benefit.backContent}
                    </p>
                  )}
                  {/* <button className="partners-benefits-register-btn">
                  Register as a Partner
                </button> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnersContentTwo;
